import { observable } from "micro-observables";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { metricGroupsRequest } from "modules/Metric/api";
import arrayToMap from "utils/arrayToMap";

export const isLoadingGroups = observable(false);
export const metricGroupsCount = observable(0);
export const metricGroups = observable([]);
export const metricGroupsMap = observable({});
export const menuMetricGroups = observable([]);
export const menuMetricGroupsMap = observable({});

export const setMetricGroupsList = (list) => {
    metricGroups.set(list);
};

export const setIsLoadingGroups = (state) => {
    isLoadingGroups.set(state);
};

export const setMetricGroupsCount = (count) => {
    metricGroupsCount.set(count);
};

export const setMetricGroupsMap = (map) => {
    metricGroupsMap.set(map);
};

export const setMenuMetricGroupsList = (map) => {
    menuMetricGroups.set(map);
};

export const setMenuMetricGroupsMap = (map) => {
    menuMetricGroupsMap.set(map);
};

export const requestMetricGroupsInitialData = async (isShouldRequest) => {
    try {
        const groupsCount = metricGroupsCount.get();
        if(groupsCount && !isShouldRequest) {
            return;
        }

        setIsLoadingGroups(true);

        const { metric_groups, count } = await metricGroupsRequest();

        const groupsMap = arrayToMap(metric_groups, "code");

        setMetricGroupsList(metric_groups);
        setMetricGroupsCount(count);
        setMetricGroupsMap(groupsMap);
    } catch (error) {
        getErrorMessage(error);
    } finally {
        setIsLoadingGroups(false);
    }
};

export const requestMetricGroups = async () => {
    const { metric_groups, count } = await metricGroupsRequest();

    const groupsMap = arrayToMap(metric_groups, "code");

    setMetricGroupsList(metric_groups);
    setMetricGroupsCount(count);
    setMetricGroupsMap(groupsMap);
};

export const requestMenuMetricGroups = async () => {
    const { metric_groups } = await metricGroupsRequest({ has_metrics: 1 });
    const groupsMap = arrayToMap(metric_groups, "code");

    setMenuMetricGroupsList(metric_groups);
    setMenuMetricGroupsMap(groupsMap);
};

export const clearMetricGroupsData = () => {
    setMetricGroupsList([]);
    setMetricGroupsMap({});
    setMetricGroupsCount(0);
    setIsLoadingGroups(false);
};
